import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, tap } from 'rxjs';
import { User } from './models';
import { AuthService } from './auth.service';

export const crmGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const http = inject(HttpClient);
  const signIn = router.createUrlTree(['/crm/signin']);
  if (!localStorage.getItem('liiji.token')) {
    return signIn;
  }
  const allow = (user: User) => (user.role === 'ADMIN' || user.role === 'AGENT' ? true : signIn);
  const current = auth.user();
  if (current?.role) {
    return allow(current);
  }
  return http.get<User>('/api/auth/me').pipe(
    tap((user) => auth.remember(user)),
    map(allow),
    catchError(() => of(signIn)),
  );
};
